import { createSlice } from "@reduxjs/toolkit";

const initialIssuesStatusesState = {};

const editIssuesSlice = createSlice({
  name: "editIssues",
  initialState: initialIssuesStatusesState,
  reducers: {
    setEditIssuesData: (_state, action) => action.payload,
  },
});

export const { setEditIssuesData } = editIssuesSlice.actions;

export const editIssues = editIssuesSlice.reducer;

export default editIssuesSlice.reducer;
